/**
 * Extend Marb V1 namespace to be implement old objects in a different way.
 * We use this to share common code like mercadopago.tags with the same callbacks.
 *
 * @author aobara
 */

try {
    Marb.extend({
        Page : {
            Toast: {
                defaultToast: '<div class="ifix-toast"><i class="fa" aria-hidden="true"></i><span></span></div>',
                defaultRender: function(config) {
                    var delay = config.delay || 2500;
                    var text = config.text || "";
                    var style = config.style || "toast-success";
                    var icon = config.icon || "fa-times-circle";
                    var callback = config.callback;
                    var container = config.container || "body";
                    var position = config.position || "bottom"; //bottom or top
                    var positionNumber = (position == 'bottom' ? '0' : $("#main-header").outerHeight());
                    var element = $(this.defaultToast);
                    $(element).addClass(style).css(position, positionNumber);
                    $(element).find('.fa').addClass(icon);
                    $(element).find('span').html(text);
                    $(element).appendTo($(container)).show("slide", {
                        direction: "up"
                    }, function() {
                        $(this).delay(delay).hide("slide", {
                            direction: "up"
                        }, function(){ $(element).remove(); callback; });
                    });
                },
                success: function(a) {
                    a = a || {};
                    a.style = "toast-success";
                    M.Page.Toast.defaultRender(a);
                },
                warn: function(a) {
                    a = a || {};
                    a.style = "toast-warning";
                    M.Page.Toast.defaultRender(a);
                },
                error: function(a) {
                    a = a || {};
                    a.style = "toast-error";
                    a.icon = "fa-times-circle";
                    M.Page.Toast.defaultRender(a);
                }
            }
        }
    });
}
catch (e) {
    console.log("Marb namespace not present", e);
}